import NodeView from './NodeView'
import FullView from './FullView'

const Person = {
  NodeView, FullView
}

export default Person